import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c93a43e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "operation" }
const _hoisted_3 = { class: "bottom" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "custom-tree-node" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "del-icon" }, null, -1))
const _hoisted_8 = { class: "right" }

import { onMounted, ref, computed } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import UserModal from './components/user-modal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  queryUserPage,
  queryUserDelete,
  queryUsersCurrentFull,
  queryOrgTreeList,
} from '@/api'
import moment from 'moment'
import i18n from '@/i18n'
import OperationButtonList from '@/components/operation-button-list'
import { isEmpty } from 'lodash'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {

const authStore = useAuthStore()

const isSuperAdmin = computed(() => {
  return authStore.isSuperAdmin
})
const t = i18n.global.t

const handleNodeClick = (value: any) => {
  currentKey.value = value.id
  pageParams.value.curPage = 1
  fetchList()
}

const getButtonList = (row: any) => {
  const admin = row.isSuperAdmin
  return admin
    ? []
    : [
        {
          type: 'edit',
          text: t('CONFIG.btnEdit'),
        },
        {
          type: 'delete',
          text: t('CONFIG.btnDel'),
        },
      ]
}

const toEdit = (data: any) => {
  userConf.value = {
    visible: true,
    data,
  }
}

const toShowRemoveTips = async ({ userId }: any) => {
  ElMessageBox.confirm(t('CONFIG.delTip'), t('CONFIG.delTitle'), {
    confirmButtonText: t('CONFIG.btnDelete'),
    cancelButtonText: t('CONFIG.btnCancel'),
    cancelButtonClass: 'ws_mt15',
    confirmButtonClass: 'ws_mt15 ws_ml16',
    customStyle: {
      padding: '10px',
    },
  })
    .then(() => {
      removeUser(userId)
    })
    .catch(() => {})
}

const removeUser = async (userId: any) => {
  const res: any = await queryUserDelete({
    userIds: [userId],
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(t('CONFIG.delSuccess'))
    fetchList()
  } else {
    ElMessage({
      message: res?.msg,
      type: 'error',
    })
  }
}

const advancedRef = ref()

const columns: any = ref([
  {
    prop: 'username',
    label: t('CONFIG.colUserName'),
  },
  {
    prop: 'nickname',
    label: t('CONFIG.colNickname'),
  },
  {
    prop: 'orgName',
    label: t('CONFIG.labelOrg'),
  },
  {
    prop: 'roleName',
    label: t('CONFIG.colRoleName'),
  },
  {
    prop: 'createTime',
    label: t('CONFIG.colCreateTime'),
    formatter: (row: any) => {
      return moment(row.createTime).format('YYYY-MM-DD HH:mm')
    },
  },
])

const userConf = ref({
  visible: false,
  data: {},
})

const tableData: any = ref([])
const formInline = ref({
  nickname: '',
  username: '',
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = (pageSize: number) => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = (pageSize: number) => {
  fetchList()
}

const getOrgId = () => {
  return {
    orgId: currentKey.value,
  }
}

const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
    currentKey.value = orgTreeData.value[0]?.id
  }
  tableLoading.value = true

  const res: any = await queryUserPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    ...getOrgId(),
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(async () => {
  await queryOrgTreeListData()
  fetchList()
})

const showModal = () => {
  userConf.value = {
    visible: true,
    data: getOrgId(),
  }
}

const deepFormat = (
  list: any,
  level = 0,
  topOrgName = '-',
  parentOrgId?: any
) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      name,
      value: id,
      id,
      label: name,
      children: deepFormat(children, level + 1, name, id),
      level: level + 1,
      topOrgName,
      parentOrgId,
      class: 'node_' + id,
    }
  })
}

const treeRef = ref()
const orgTreeData: any = ref([])
const currentKey = ref()
const treeKey = ref(Math.random())
const queryOrgTreeListData = async () => {
  const res: any = await queryOrgTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const result = deepFormat([res.data])
    orgTreeData.value = result

    currentKey.value = res.data?.id
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advance-container",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('CONFIG.username'),
          prop: "username"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.username) = $event)),
              clearable: "",
              maxlength: "50",
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('CONFIG.nickname'),
          prop: "nickname"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.nickname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.nickname) = $event)),
              clearable: "",
              maxlength: "50",
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(isSuperAdmin))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: showModal,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.btnCreate')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_tree, {
          ref_key: "treeRef",
          ref: treeRef,
          class: "tree-list",
          data: orgTreeData.value,
          onNodeClick: handleNodeClick,
          "default-expand-all": "",
          "expand-on-click-node": false,
          "node-key": "id",
          "highlight-current": true,
          "current-node-key": currentKey.value
        }, {
          default: _withCtx(({ node }) => [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(node.label), 1),
              _hoisted_7
            ])
          ]),
          _: 1
        }, 8, ["data", "current-node-key"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "ws_common_table",
          data: tableData.value,
          stripe: ""
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('CONFIG.noData')
            }, null, 8, ["description"])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: item.prop,
                prop: item.prop,
                label: item.label,
                formatter: item.formatter,
                "show-overflow-tooltip": ""
              }, null, 8, ["prop", "label", "formatter"]))
            }), 128)),
            (_unref(isSuperAdmin))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "logType",
                  width: 280,
                  label: _ctx.$t('CONFIG.operation')
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_unref(OperationButtonList), {
                      buttonList: getButtonList(scope.row),
                      scope: scope.row,
                      onOnEdit: toEdit,
                      onOnDelete: toShowRemoveTips
                    }, null, 8, ["buttonList", "scope"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(UserModal, {
      visible: userConf.value.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((userConf.value.visible) = $event)),
      data: userConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ]))
}
}

})